export default function findFormInvalidity(form,scene,forms){


  

  let formLines = forms[scene].formLines.flat();
  let { optional } = forms[scene];
  let requiredFormLines = formLines;
  if( optional ){

    requiredFormLines = formLines.filter(line => !optional.has(line));
  }



  let emptyField = (requiredFormLines.find(field => {
    return !form[field] || form[field].length === 0
  }))





  if( emptyField ){



    let formattedFieldName = emptyField.replace(/[A-Z]/g,(m) => ' ' + m.toLowerCase()).replace(/^./,(m) => m.toUpperCase()) 



    return (formattedFieldName + " required.");
  }

  if( 'password' in form && 'confirmPassword' in form ){
    let pw = form.password;
    let cpw = form.confirmPassword;
    if( pw !== cpw ){
      return "Passwords do not match.";
    }
  }


}
